<palantir-accordion
  [title]="definition().label"
  [open]="true"
  #listBox
  cdkListbox
  (cdkListboxValueChange)="handleRadioChange($event.value)"
>
  @if (canShowFilter()) {
    <div class="select-input">
      @if (definition().description?.length) {
        <palantir-text class="select-input__description" size="base" type="description">{{
          definition().description
        }}</palantir-text>
      }
      @if (definition().search && definition().search?.enabled) {
        <palantir-input prefix="search-outline">
          <input
            type="text"
            [placeholder]="definition().search?.placeholder"
            [formControl]="searchControl"
            (keydown.space)="stopSpacePropagation($event)"
          />
          <palantir-filter-modal-error-display
            palantir-input-error
            [control]="control()"
            [validatorsMessages]="definition().validatorsMessages"
          />
        </palantir-input>
      }
      <div class="select-input__options palantir-scrollbar">
        @if (definition().nullOption && filteredOptions().length) {
          <div
            class="select-input__options__option"
            [ngClass]="{
              'select-input__options__option--with-description':
                definition().nullOption?.description,
            }"
          >
            <palantir-radio
              (click)="clearOption()"
              [attr.aria-selected]="control().value === null ? 'true' : ''"
            />
            <palantir-filter-modal-option
              [textType]="'description'"
              [option]="addValueToNullOption(definition().nullOption!)"
              (click)="clearOption()"
            />
          </div>
        }
        @for (option of filteredOptions(); track option.value) {
          <div
            class="select-input__options__option"
            [ngClass]="{
              'select-input__options__option--with-description': option.description,
            }"
          >
            <palantir-radio
              [cdkOption]="option.value"
              [attr.checked]="control().value === option.value ? 'checked' : null"
            />
            <palantir-filter-modal-option
              [option]="option"
              (click)="control().setValue(option.value)"
            />
          </div>
        } @empty {
          @if (definition().search && definition().search?.enabled) {
            <div class="select-input__empty-message">
              <palantir-icon name="search-outline" class="select-input__empty-message__icon" />
              <palantir-text size="base" type="description">{{
                definition().search?.emptyMessage
              }}</palantir-text>
            </div>
          }
        }
      </div>
    </div>
  } @else {
    <div class="filter-dialog__banner">
      <palantir-icon name="info-outline" class="filter-dialog__banner__icon" />
      <palantir-text size="base" type="description">{{
        definition().dependsOn?.placeholder
      }}</palantir-text>
    </div>
  }
</palantir-accordion>
